import React from 'react'
import PropTypes from 'prop-types'
import Decimal from 'decimal.js'

import useCheckoutPayment from 'hooks/useCheckoutPayment'
import * as STEPS from 'constants/checkout-steps'
import { currencyFormat } from 'utils/format'

import { SideMenu as Menu } from 'components/SideMenu'
import { Step, Label, Value } from './styles'

export default function SideMenu({ step }) {
  const [
    {
      paymentPlans,
      totalPaid,
      totalToPay,
      change_value: changeValue,
    },
    {
      totalValue,
    },
  ] = useCheckoutPayment()

  const toRenderTotalPaid = () => {
    const [firstPlan] = paymentPlans

    return firstPlan?.selected_method_option?.value
      || step === STEPS.CHECKOUT_PAYMENT_METHODS
  }

  const toRenderBalance = () => (
    toRenderTotalPaid() || step === STEPS.CHECKOUT_PAYMENT_CONFIRMATION
  )

  const getBalanceCss = (balance) => {
    const val = new Decimal(balance)

    if (val.isNegative()) return 'negative'
    if (val.isPositive()) return 'positive'
    return 'zero'
  }

  const renderPamentItemMenu = () => (
    <Step>
      <Label>
        A pagar:
      </Label>
      <Value>
        {currencyFormat(totalToPay)}
      </Value>
    </Step>
  )

  const renderPamentPlanMenu = () => {
    if (!toRenderTotalPaid()) return null

    return (
      <Step>
        <Label>
          Pago:
        </Label>
        <Value>
          {currencyFormat(totalPaid)}
        </Value>
      </Step>
    )
  }

  const renderBalance = () => {
    if (!toRenderBalance()) return null
    const balance = totalValue()

    return (
      <>
        <Step>
          <Label>
            Troco:
          </Label>
          <Value>
            {currencyFormat(changeValue)}
          </Value>
        </Step>
        <Step>
          <Label>
            Saldo:
          </Label>
          <Value className={getBalanceCss(balance)}>
            {currencyFormat(balance)}
          </Value>
        </Step>
      </>
    )
  }

  return (
    <Menu>
      <div>
        { renderPamentItemMenu() }
        { renderPamentPlanMenu() }
        { renderBalance() }
      </div>
    </Menu>
  )
}

SideMenu.propTypes = {
  step: PropTypes.string.isRequired,
}
